<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <Modal
      class="modal_div"
      v-model="modal1"
      :title="ref"
      width="830px"
      class-name="vertical-center-modal"
      @on-visible-change="onChange"
    >
      <div slot="header">
        <Row>
          <Col span="20">
            <span class="header_div">{{ item01.ref }}</span>
          </Col>
          <Col span="3"> </Col>
        </Row>
      </div>
      <div class="wid_img">
        <div>
          <img :src="item01.photoUrl" alt="暂无图片" />
        </div>
        <div class="Introduction">
          <!-- <div class="">
            价 格: <span style="color: #1966ff">{{ item01.money }}</span>
          </div> -->
          <div class="Introduction__p">介 绍：{{ item01.p }}</div>
          <div class="phone">
            咨询电话: <span style="color: #1966ff"> 18001306738</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="modal1 = false">取消</Button>
        <!-- <Button @click="skip">前往购买</Button> -->
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "Resiliometer",
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      Img: "",
      photoArr1: [
        /*回弹仪*/
        {
          photoUrl: "../../../static/img/photo/photo_huitan.png",
          p: "数字回弹仪是针对混凝⼟抗压强度检测所研制的⾼科技产品，适⽤于各类建筑⼯程中普通混凝⼟抗压强度的⽆损检测。能即时获得被抽检混凝⼟结构抗压强度的检测结果。体现检测的公正性、科学性和准确性，极⼤地提⾼检测、数据处理与检验报告编制的⼯作效率。",
          ref: "智能回弹仪",
          money: "¥4500.00",
        },
        /*智能靠尺*/
        {
          photoUrl: "../../../static/img/photo/photo_rule.png",
          ref: "数字蓝牙智能靠尺",
          money: "￥30.00-￥680.00",
          p: "在传统靠尺上加装模块，可⾃由拆卸。数据采集、初步结果计算、数据传输通过硬件完成。",
        },
        /*测距仪*/
        {
          photoUrl: "../../../static/img/photo/photo_ceju03.jpg",
          ref: "智能测距仪",
          money: "￥120.00",
          p: "智能测距仪作为⼀种精密的测量⼯具，利⽤调制的某个参数对⽬标的距离进⾏准确测定的仪器。⽀持单次测量、连续测量、⾯积测量、体积测量、勾股定理间接测量、加减测量功能。",
        },
        /*游标卡尺*/
        {
          photoUrl: "../../../static/img/photo/VernierCaliper01.png",
          ref: "游标卡尺",
          money: "¥900.00",
          p: "游标卡尺是⼀种测量⻓度、内外径、深度的量具。游标卡尺由主尺和附在主尺上能滑动的游标两部分构成。若从背⾯看，游标是⼀个整体。深度尺与游标尺连在⼀起，可以测槽和筒的深度。",
        },
        /*智能卷尺*/
        {
          photoUrl: "../../../static/img/photo/tape.png",
          p: "智能卷尺是一种利用科技手段将传统卷尺的测量功能与数字化、智能化的技术相结合，实现更加高效准确的测量工具。它主要通过在卷尺上增加显示屏、传感器等手段，实现对测量数据的实时显示和记录，并可根据用户需求进行数据分析和处理。",
          ref: "智能卷尺",
          money: "",
        },
        /*阴阳角尺*/
        {
          photoUrl: "../../../static/img/photo/square.png",
          p: "检测阴阳角内外直角偏差的常见工具。使用多功能内外直角检测尺能检测墙面内外(阴阳)直角的偏差。",
          ref: "阴阳角尺",
          money: "",
        },
        /*钢筋扫描仪*/
        {
          photoUrl: "../../../static/img/photo/scanister.png",
          p: "主要用于工程建筑混凝土结构中钢筋分布、直径、走向，混凝土保护层厚度质量的检测。钢筋扫描仪能够在混凝土的表面测定钢筋的位置、布筋情况、测量混凝土保护层厚度 、 钢筋直径等。",
          ref: "钢筋扫描仪",
          money: "",
        },
        /*楼板测厚仪*/
        {
          photoUrl: "../../../static/img/photo/floor.png",
          p: "无线楼板厚度检测仪，用于测量现浇楼板 、 混凝土或墙、柱、梁、木材以及陶瓷等其它非金属厚度的便携式智能无损检测设备。",
          ref: "楼板测厚仪",
          money: "",
        },
        /*塞尺*/
        {
          photoUrl: "../../../static/img/photo/feelergauge.png",
          p: "智能塞尺是一种集成了传感器和计算机技术的测量工具，可以自动记录和处理测量数据，以提高测量效率和准确性。智能塞尺通常用于精密测量和质量控制领域。",
          ref: "智能塞尺",
          money: "",
        },
        /*混凝土碳化深度检测仪*/
        {
          photoUrl: "../../../static/img/photo/carbide.png",
          p: "混凝土碳化深度检测仪是一种用于检测混凝土表面碳化深度的仪器。它通过测量混凝土表面与钢筋之间的电位差来确定碳化深度，可以帮助评估混凝土结构的耐久性和安全性。通常使用无损检测方法进行检测，对于维护和评估建筑物、桥梁等混凝土结构具有重要意义。",
          ref: "混凝土碳化深度检测仪",
          money: "",
        },
        /*水平仪感光测距仪*/
        {
          photoUrl: "../../../static/img/photo/level.png",
          p: "水平仪感光测距仪是一种测量距离和高度的光学仪器。它基于三角形相似原理，通过测量目标物体在水平仪视野中的高度和水平距离，计算出目标物体与观察者之间的距离。水平仪感光测距仪结构简单，使用方便。",
          ref: "水平仪感光测距仪",
          money: "",
        },
        /*实测实量机器人*/
        {
          photoUrl: "../../../static/img/photo/Therobot.jpg",
          p: "基于空间点云智能分析技术、大数据处理技术和云计算技术的自动化、数字化的实测实量管理系统，是新一代的实测实量解决方案。它可以实现智能化的数据采样、数据处理和实测成果评估，并能够及时输出整改报告和图纸，可实现对实测实量工作的远程管理与监控",
          ref: "实测实量机器人",
          money: "",
        },
        /*磁粉探伤仪*/
        {
          photoUrl: "../../../static/img/photo/Flawdetector.png",
          p: "磁粉探伤仪是一种利用磁粉检测工件表面缺陷和裂纹的非破坏性检测仪器。它通过在被检测物体表面施加磁场，将磁粉喷洒到表面，在磁场作用下，如果有缺陷或裂纹，磁粉会聚集在该处形成可见的磁粉堆积线，从而进行缺陷检测。磁粉探伤仪广泛应用于金属制品、航空航天、铁路运输等领域的质量控制和安全检测中。",
          ref: "磁粉探伤仪",
          money: "",
        },
        // 顶板极差
        {
          photoUrl: "../../../static/img/photo/Roofplate.png",
          photoUrl1: "../../../static/img/photo/Roofplate.png",
          p: "提高工作效率：二合一工具减少了工具更换的次数，使工人能够更快地完成测量和校正工作。提升测量精度：结合了水平仪和靠尺的功能，能够同时满足水平和垂直度的测量需求，提高整体测量精度。节省空间：二合一设计使得工具更加紧凑便携，便于在狭小的工作环境中使用。降低成本：相比单独购买水平仪和靠尺，二合一工具通常具有更高的性价比。",
          ref: "顶板极差",
          money: "",
        },
      ],
    };
  },

  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
      this.Img = item.Img;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
    // 跳转
    skip() {
      window.open("https://supply-chain.nanxiushuzi.com/");
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 10px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  align-items: center;
}

.wid_img img {
  width: 364px;
  height: 330px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
  margin-top: -36px;
}

.phone {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/Resiliometer.vue